import React, { useEffect, useContext } from 'react';
import { withRouter, useHistory } from "react-router-dom";
import Helper from '../../common/Helper';
import axios from 'axios';
import APIURLConstants from '../../common/ApiURLConstants';
import { authenticationService } from '../../services';
import RouteConstants from '../../common/RouteConstants';
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { loginRequest } from '../../config/authConfig';
import { AppDataContext } from '../../common/AppContext';
import { defineDefaultRules } from '../../common/Permission';
import { AbilityContext } from '../../common/Can';


const Logout = (props) => {
    const ability = useContext(AbilityContext)
    const { instance, accounts } = useMsal();
    const history = useHistory();
    const isAuthenticated = useIsAuthenticated();
    const { resetAppContext } = useContext(AppDataContext);
    const handleLogout = async (val) => {
        try {
            authenticationService.setCurrentUser(null);
            let res = await authenticationService.logout()

            resetAppContext();
            let rules = defineDefaultRules()
            ability.update(rules)
            console.log("Logout successful:", res);
            if (val !== 'sso') {
                // If not SSO, redirect to login page
                history.push(RouteConstants.OFFICIAL_LOGIN);
            }

        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        const logout = async () => {


            // If using MSAL, you can also call instance.logoutRedirect() to clear the session
            if (isAuthenticated) {
                instance
                    .acquireTokenSilent({
                        ...loginRequest,
                        account: accounts[0],
                    })
                    .then(async (response) => {
                        console.log(response);
                        await handleLogout('sso');
                        await instance.logoutRedirect({
                            postLogoutRedirectUri: RouteConstants.OFFICIAL_LOGIN
                        });


                    })
            } else {
                await handleLogout();
            }


            //var accesstoken = localStorage.getItem('accessToken')
            //if (accesstoken && accesstoken !== "") {
            // axios.get(APIURLConstants.SIGNOUT) //, { headers: { 'Authorization': `Bearer ${accesstoken}` } }
            //     .then(async res => {
            //         //if (Helper.getStorage('chk') == 'aad') {
            //             //localStorage.clear()
            //             //await instance.logoutRedirect();

            //         //}

            //         Helper.Logout();

            //     })
            //} else {
            //    window.location.href = '/';
            // }



        }
        logout();
    }, [])

    return (
        <></>
    );
}

export default withRouter(Logout);